import React from 'react';

import {themeGet} from '@styled-system/theme-get';
import {FireworkCTA} from 'src/components/controls';
import {Box, BoxProps, Flex, LayoutGrid} from 'src/components/shared';
import {Typography} from 'src/components/shared/fireworkTypography';
import {HOME} from 'src/routes/paths';
import {fonts} from 'src/styleguide/fireworkTypographyStyles';
import {Icon, Icons} from 'src/svgs';
import {applyPage} from 'src/utils/copy';
import styled from 'styled-components/macro';

const {H3} = Typography;

export type SubmittedOverlayProps = BoxProps & {isOpen: boolean; customSuccessMessage: string};

const Wrapper = styled(Box).attrs({
  pt: '4.5rem',
})<{isOpen: boolean}>`
  opacity: ${props => (props.isOpen ? 1 : 0)};
  transition: opacity 200ms ease;
  pointer-events: ${props => (props.isOpen ? 'auto' : 'none')};
`;

const StyledH3: typeof H3 = styled(H3).attrs({
  fontSize: ['1.875rem', null, null, '2rem'],
  lineHeight: ['1.875rem', null, null, '2rem'],
})``;

export const SubmittedOverlay: React.FC<SubmittedOverlayProps> = ({isOpen, customSuccessMessage, ...props}) => {
  return (
    <Wrapper isOpen={isOpen} aria-hidden={!isOpen}>
      <StyledH3>{customSuccessMessage}</StyledH3>
    </Wrapper>
  );
};

SubmittedOverlay.defaultProps = {};
